import { MachineApprovalStatus } from '../../constants/machine/machine.constant';
import { useGetMyPopularTractor } from '../api/user/queries/useGetMyPopularTractor';

export const useSalesConversionTractors = () => {
  const { APPROVAL, PSWAITING } = MachineApprovalStatus;

  const { data: publicTractor } = useGetMyPopularTractor({
    searchParam: { machineApprovalStatus: `${APPROVAL},${PSWAITING}`, isPokeEnabled: true },
  });

  const { data: sellablePrivateTractor } = useGetMyPopularTractor({
    searchParam: { machineApprovalStatus: `${APPROVAL},${PSWAITING}`, isPokeEnabled: false },
  });

  const popularTractor = publicTractor && publicTractor?.pokedAt ? publicTractor : null;
  const sellableTractor = publicTractor && !publicTractor?.pokedAt ? publicTractor : sellablePrivateTractor;

  return {
    popularTractor,
    sellableTractor,
  };
};
